<script>
  import { onMount } from 'svelte';
  import Modal from 'sv-bootstrap-modal';
  import { flashMessage, searchToObject, getRadioVal, setRadioVal }  from './jsutils.js';
  import jQuery from 'jquery';
  //VARIABLE DEFINITION
  
  let comment = {'history':[],'model':'Most important improvement','Category':'','Response':'','SurveyInviteCode':'','SurveyQuestionID':'','CategoryLookup':'','Client':'','Question':'','collected_date':''};
  let preloaded_comments = [];
  let choices = {};
  let terminal_position=false;
  let search_query = searchToObject(window.location.search);
  search_query['csrf_token'] = jQuery('#csrf_token').val();
  search_query['local_history'] = [];
  let no_more_comments_flag = false; //use this for when we reach the end of the comments for this client, but still have some in the preloaded queue
  if (search_query.hasOwnProperty('CategoryLookup')){no_more_comments_flag=true;} //if we are editing a comment, we already know there isn't going to be anything else to collect
  let waiting_on_server = true;  
  let model = comment['model'];
  let predicted_category = '';
  let current_user = '';
  current_user = jQuery('#current_user').val();
  let questions=[];
  var colors = ['blue', 'yellow', 'green', 'red'];
  let columns = [];
  let show_model_modal = false;
  let show_KBModal = false;
  //FUNCTIONS
  function convert_choices_to_columns(choices){
    // cols = [[{'other':[{'value':'','display':''}]}]] //example data structure
    var columns = [[{legend:'Sentiment',categories:[{display:"Positive",value:"Positive",class:'green'},{display:"Neutral",value:'Neutral',class:'yellow'},{display:'Negative',value:'Negative',class:'red'}],grouping_num:0}],[],[]];
    var grouping_num = -1;
    var idx = 0;
    for (const _g of choices[model]) {
      var grouping = _g[0]
      var value = _g[1]
      grouping_num+=1;
      idx+=1;
      if (idx == 3){idx=0}
      columns[idx].push({legend:grouping,categories:value,grouping_num:grouping_num})
  }
  return columns;
  }

  function skip_function(){
      if (preloaded_comments.length == 0){
        if (no_more_comments_flag){
          flashMessage('No more comments to categorize!','success');
          unlockHeader();
        }
        else{return null}
      }
      comment = preloaded_comments.shift();
      displayComment(comment);
      preloaded_comments = preloaded_comments;
      collectCommentData();
    }
    // add this in a future update. For now just redirect
    // function apply_question_filter(question){
    //   // add the question filter to the search_query
    //   // remove any preloaded_comments that aren't the right question
    //   if (preloaded_comments.length == 0){collectCommentData()}
    //   // if the current comment is of the wrong question, skip
    //   if (comment['Question'] != question){skip_function()}
    // }

    function changeModel(new_model){
      model = new_model;
      columns = convert_choices_to_columns(choices);
      setRadioVal('sentiment',comment['Sentiment']); //set default sentiment based on predicted or previous
      setRadioVal('categories',comment['Category']); //set default category based on predicted or previous
    }

function collectCommentData(){
      // don't pick up any more comments because there are none left //if CategoryLookup is in search_params, no_more_comments_flag is true, but the first time we collect the original catlookup was '' because it was a dummy filler from the let statement.
      if (no_more_comments_flag&&comment['CategoryLookup']!=''){return}
      //stop picking up comments once we already have a few
      if (preloaded_comments.length > 5){return}
      var number_to_collect = 15;
      // if (preloaded_comments.length < 2){number_to_collect=} //initially collect more comments //this idea was abandoned because it was too slow, people categorized faster than comments could be loaded
      
      jQuery.ajax({
      url: "/get-comment?limit="+number_to_collect,
      type: 'POST',
      data: search_query,
      success: function(result){
        console.log('COLLECTED COMMENT')
        console.log(result);
        for (const _c of result['comments']) {
          // if the new comment is one that we added to the local_history to avoid collecting during the small delay between request and response, ignore this comment and run this function again
        if (search_query['local_history'].includes(_c['CategoryLookup'])){
          console.log('WE AVOIDED A DUPLICATE');
        }
        else{
          preloaded_comments.push(_c);
          search_query['local_history'].push(_c['CategoryLookup']);
        }
        }
        preloaded_comments = preloaded_comments; //need to do this so svelte reactively updates this variable
        search_query = search_query;
        jQuery("#other_field_holder").show(); //this starts out hidden, but only needs reset to blank later, so it is truly a one time setup, but it can be here because I don't know where else to put it
      }, //end success
      error: function(result){
        console.log('ERROR');
        console.log(result);
        
        if (result['responseText'].match(/Could not find data for your request/)){
          no_more_comments_flag = true;
          if (comment['CategoryLookup']==''){flashMessage(result['responseText'],'warning');unlockHeader();}
        }
        else{
          flashMessage(result['responseText'],'warning');
          unlockHeader();
        }
        
      }, //end error
      complete: function(result){
        if(waiting_on_server){
            comment = preloaded_comments.shift();
            preloaded_comments = preloaded_comments;
            comment = comment;
            displayComment(comment); //we already added to preloaded_comments in the success function  
          
          }
        if(preloaded_comments.length < 2){
          collectCommentData();
          } //note that this happens after shift (pop)
      } //end complete
    }); //end ajax
    }//end function collectCommentData()


function form_submit(e){
    console.log('form submitted');
    //give visual signal that we are working on the submit
    waiting_on_server = true;
    jQuery("#filterInput").val('');
    //get the data into json
    var formData = jQuery("#CategorizationForm").serializeArray();
    console.log(formData);
    // jQuery.ajaxSetup({beforeSend: function(xhr, settings) {if (!/^(GET|HEAD|OPTIONS|TRACE|POST)$/i.test(settings.type) && !this.crossDomain) {xhr.setRequestHeader("X-CSRFToken", csrf_token);}}});
    jQuery.ajax({
        type: "POST",
        headers: {'X-CSRFToken':csrf_token},
        url: "/post-comment",
        data: formData,
        success: function(result){
          console.log('post comment success response');
          console.log(result);
        }, //end success
        error: function(result){
          console.log('Form Submit Error');
          console.log(result);
          flashMessage('The previous comment failed to upload<br>'+result.responseText.toString().replace(/\\n/g,'<br>'),'danger');
          unlockHeader();
        }, //end error
        complete: function(result){
          if (preloaded_comments.length > 0){
            comment = preloaded_comments.shift()
            comment = comment;
            displayComment(comment); //display the next comment
            waiting_on_server=false;
            preloaded_comments = preloaded_comments; // make this reactive to the rest of the page
          }
          else if (preloaded_comments.length==0&&no_more_comments_flag){ //they have reached the end of the comments for this client
            flashMessage('No more comments to categorize!','success');
            unlockHeader();
            waiting_on_server = false;
            terminal_position = true;
          }
          collectCommentData(); //collect another comment so we don't run out
        }
    });//end ajax post
    };//end on form.submit


    function displayComment(comment){
      predicted_category = comment['Category'];
      jQuery("#other").val(undefined);//set the other text box to nothing
      setRadioVal('sentiment',comment['Sentiment']); //set default sentiment based on predicted or previous
      setRadioVal('categories',comment['Category']); //set default category based on predicted or previous
      changeModel(comment['model']);
      //visual changes to indicate you can use the page
      waiting_on_server = false;
      headersize();
    }// end function displayComment()

//BELOW are functions that don't need modified
  function sleep(ms) {return new Promise(resolve => setTimeout(resolve, ms));}
  async function wait_then_headersize(){await sleep(200); headersize();}
  $: {comment; wait_then_headersize();} //when a new comment is loaded, wait for it to display on the page, then run headersize
  function headersize() {
    if (jQuery('#unlock_header').css('display') == "none") {
      jQuery('#main_form').css('margin-top', '20px');
    }
    else {
      jQuery('#main_form').css('margin-top', (jQuery('#comment_info').innerHeight()));
    }
  };
  function unlockHeader() {
    jQuery('#comment_info').css('position', 'relative');
    jQuery('#comment_info').css('margin-top', '0px');
    jQuery('#comment_info').css('z-index', '20');
    jQuery('#main_form').css('margin-top', '20px');
    jQuery('#unlock_header').css('display', 'none');
    jQuery('#history_holder').css('margin-top', 'auto');
  }
  $: { //this statement is reactive to show_KBModal, basically it listens for changes in show_KBModal and then does the rest
        show_KBModal;
      //this fires off when the modal is fully hidden after closing
      // reset the text field and focus it
      jQuery("#filterInput").focus();
      jQuery("#filterInput").val('');
      filterChoices();
    }

    function filterChoices() {
    var input = document.getElementById("filterInput");
    if (input === null){return}
    var filter = input.value.toUpperCase();

    // If they directly type a control button, give it to them
    if (filter == "SKIP") {
      jQuery('a[href="/skip"]')[0].focus();
      jQuery('a[href="/skip"]')[0].click();
    }
    if (filter == "SUBMIT") {
      jQuery('#submit')[0].focus();
      jQuery('#submit')[0].click();
    }
    if (filter == "+") { jQuery("#Positive").prop('checked', true); }
    if (filter == "NEU") { jQuery("#Neutral").prop('checked', true); }
    if (filter == "-") { jQuery("#Negative").prop('checked', true); }

    var choices = jQuery('.custom_radio_buttons input[name!="sentiment"]')
    // for each input, if the input value matches the filter text show the corresponding label, else hide
    for (var i = 0; i < choices.length; i++) {
      if (choices[i].value.toUpperCase().indexOf(filter) > -1) {
        jQuery(`label[for="${choices[i].id}"]`).show();
      } else {
        jQuery(`label[for="${choices[i].id}"]`).hide();
      }
    }

    // if there is only one label visible (not counting sentiment selections) then select that label
    var still_visible = jQuery('.custom_radio_buttons input[name!="sentiment"] + label:visible');
    if (still_visible.length == 1) {
      var input_sv = jQuery(`#${still_visible[0].getAttribute('for')}`);
      comment['Category'] = input_sv.val();
      comment = comment;
    }
    jQuery('.custom_radio_buttons input[name!="sentiment"]').radioTabbable();

    // for each group header (legend) if there are no labels showing for that group, hide the legend
    var legends = jQuery(".legend[group]");
    legends.each(function (i) {
      if (jQuery(`label[group="${legends[i].getAttribute('group')}"]:visible`).length == 0&&legends[i].getAttribute('group')!='Sentiment') { 
          jQuery(this).hide(); 
      }
      else { jQuery(this).show() }
    });
  }
    //END FUNCTIONS
    //SCRIPTING
    let csrf_token = jQuery("#csrf_token").val();//get the csrf token from the value of a hidden field
    // console.log('CSRF',csrf_token)
    // CSRF setup https://flask-wtf.readthedocs.io/en/1.0.x/csrf/
    jQuery.ajaxSetup({beforeSend: function(xhr, settings) {if (!/^(GET|HEAD|OPTIONS|TRACE|POST)$/i.test(settings.type) && !this.crossDomain) {xhr.setRequestHeader("X-CSRFToken", csrf_token);}}});
    let _choices = undefined;
onMount(async () => {
    _choices = fetch("/get-choices?ordered=true").then(response => response.json());
    choices = await _choices;
    collectCommentData();
    headersize();
    columns = convert_choices_to_columns(choices);
    window.onresize = headersize;
    
    jQuery("#wrong_model").click(function(){show_model_modal=true;});
    
    // when you first get to the page, collect all possible questions
    jQuery.ajax({
      url: "/get-questions",
      type: 'POST',
      data: search_query,
      success: function(result){
        questions = result['questions'];
      }, //end success
      error: function(result){
        console.log('ERROR');
        console.log(result);
        flashMessage(result['responseText'],'warning');
        unlockHeader();
      }, //end error
      complete: function(result){}
    });//end ajax get questions
    
    jQuery(document).ready(function () {
    // If they are on an ipad, don't auto focus the filterInput box
    var deviceAgent = navigator.userAgent.toLowerCase();
    var isTouchDevice = (deviceAgent.match(/(iphone|ipod|ipad)/) ||
      deviceAgent.match(/(android)/) ||
      deviceAgent.match(/(iemobile)/) ||
      deviceAgent.match(/iphone/i) ||
      deviceAgent.match(/ipad/i) ||
      deviceAgent.match(/ipod/i) ||
      deviceAgent.match(/blackberry/i) ||
      deviceAgent.match(/bada/i));

    if (!isTouchDevice) {
      // automatically focus the filterInput box on page load for easy shortcut navigation
      jQuery('#filterInput').focus();
    }
  });
  jQuery(document).bind('keyup', function (e) {
    if (e.which == 191) //191 is the code for ? question mark.
      { show_KBModal = true; } //Show keyboard shortcuts help modal
  });
  jQuery("#help_icon").click(function(){show_KBModal = true;});
  var previous = null;
  jQuery("#filterInput").bind('keyup', function (e) {
    // console.log('previous',previous,'e',e.which); //a guide to which buttons are being pressed
    if (previous == 13 && e.which == 13){ // 13 is the code for ENTER. If they press enter twice in a row it submits
    jQuery("#submit").click(); 
    previous=null; //once they press enter twice, reset previous so they are required to press it 4 times for two submits instead of 3 by mashing
    }
    else { previous = e.which }
    filterChoices();
  });

}); //end on mount
</script>

<style>
#help_icon{cursor: pointer;fill: rgba(0,0,0,0.5);}#help_icon:hover{fill: rgba(0,0,0,1);}
</style>


<div class="content-section fixed-top" id="comment_info"
  style="margin: auto; width: 100%;margin-top: 56px;z-index: 1021;">
  <div class="row">
    <div class="col-lg-6"><strong>SurveyInviteCode:</strong> { comment['SurveyInviteCode'] }</div>
    <div class="col-lg-4 col-sm-9"><strong>Comment Collected Date:</strong> { comment['collected_date'] }</div>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="col-lg-2 col-sm-3 mimic-link" id="unlock_header" on:click={unlockHeader} style="text-align: right;">Unlock header</div>

    <div class="col-lg-6"><strong>SurveyQuestionID:</strong> { comment['SurveyQuestionID'] }</div>
    <div class="col-lg-6"><strong>Question Filter: </strong>
      <select onchange="location = this.value;">
        {#if !search_query.hasOwnProperty('Question')}
        <option value="" selected hidden>-- Select a Question --</option>
        {/if}
        {#each questions as question}
        <option value="/categorize/params?Question={question}" selected={question == search_query['Question']}>{ question }</option>
        {/each}
      </select>
    </div>

    <div class="col-lg-6"><strong>CategoryLookup:</strong> { comment['CategoryLookup'] }</div>
    <div class="col-lg-6"><strong>Order by: </strong>
      <select onchange="location = this.value;">
        <option value="/categorize/params?OrderBy=CategoryLookup" selected={'CategoryLookup' == search_query['OrderBy']}>CategoryLookup</option>
        <option value="/categorize/params?OrderBy=Category" selected={'Category' == search_query['OrderBy']}>Category</option>
      </select>
    </div>
    <div class="col-lg-12"><strong>Client:</strong> { comment['Client'] }</div>
    <div class="col-lg-6" style="display: inline-block;"><strong>Question:</strong> { comment['Question'] }</div>
    <div class="col-lg-6">
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div on:click={skip_function} style="width: 80px;margin-left: 1rem;margin-right: 1rem;pointer-events: {preloaded_comments.length > 0 ? 'all' : 'none'};" class="btn btn-outline-info approve_other_button" id="skip">Skip</div>
      <!-- TODO: svelte logic for visibility of skip and loading bar   -->
      <input class="btn btn-outline-info" id="submit" name="submitbtn" on:click={form_submit} style="display:inline;" type="submit" value="Submit" disabled={waiting_on_server||terminal_position}>
        <div class="spinner-border text-primary mx-auto loading-spinner" id="loading-spinner-top" role="status" style="height: 1.5rem;width: 1.5rem; display:{waiting_on_server == true ? 'inline-block' : 'none'};"><span class="sr-only">Loading...</span></div>
    </div>

    <div class="col-12 content-section" style="margin-top: 1rem; background-color: #fff2cc;">
      <strong>Response:</strong> { comment['Response'] }
    </div>
    <!-- todo how do we set this when it becomes update by the radio buttons -->
    <div class="col-md-6"><strong>Selected Category:</strong> <span id="Category">{comment['Category']}</span></div>
    <div class="col-md-6"><input type="text" id="filterInput" placeholder="Type a category" title="Type a category">
      <div id="help_icon" class="d-inline-block">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" class="bi bi-question-circle" viewBox="0 0 16 16" fill="inherit">
          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" fill="inherit"/>
          <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" fill="inherit">
        </svg>
      </div>
      
    </div>
    <div class="col-md-6 text-muted small" id="predicted_category_holder">Predicted Category: { predicted_category }</div>
    <div class="col-md-6 text-muted small mimic-link underline" id="wrong_model">Can't find the category you need?</div>
    
  </div>
</div>
<!-- DIVIDE UPPER AND LOWER HALF -->

<div class="container-fluid" id="main_form" style="margin-top: 15rem;">
  {#if comment['history'].filter((item)=>{return item['Categorized_By']!='SYSTEM'}).length > 0}
  <div class="content-section" id="history_holder" style="margin-top: 16rem;">
    <input type="hidden" name="is_edited_comment" id="is_edited_comment" value={comment['history'].filter((item)=>{return item['Categorized_By']!='SYSTEM'}).length > 0}>
    <legend>History</legend>
    <table class="table table-bordered table-striped table-sm"><thead><tr>
      <th>Previously Categorized as</th>
      <th>Other</th>
      <th>Sentiment</th>
      <th>Categorized By</th>
      <th>Date</th>
      <th>Action</th></tr></thead><tbody>
    {#each comment['history'] as hist}
  <tr><td>{ hist['Category'] }</td>
      <td>{ hist['Other'] }</td>
      <td>{ hist['Sentiment'] }</td>
      <td>{ hist['Categorized_By'] }</td>
      <td>{ hist['Datetime'] }</td>
      <td>{ hist['Action'] }</td></tr>
    {/each}
    </tbody>
    </table>
    
    </div>
  {/if}

  <div class="content-section">
    <form method="POST" action="/post-comment" id="CategorizationForm" on:submit|preventDefault={form_submit}>
      <input type="hidden" name="is_edited_comment" id="is_edited_comment" value={ comment['history'].length > 1 }>
      <input type="hidden" name="CategoryLookup" id="CategoryLookup" value="{ comment['CategoryLookup'] }">
      <input type="hidden" name="current_user" id="current_user" value="{ current_user }">
      <fieldset class="form-group">

        <div class="container">
          <div class="row mx-lg-n4 mb-5" id="categories_holder">
            <!-- TODO: svelte logic for visibility of loading bar -->
            <!-- Decision on 2022-02-20, don't show the spinner ever, just use the top one only -->
            <!-- <div class="spinner-border text-primary mx-auto loading-spinner" role="status" style="height: 1.5rem;width: 1.5rem;"><span class="sr-only">Loading...</span></div> -->
            <!-- {JSON.stringify(columns)} -->
            {#each columns as column}
              <div class="col-12 col-lg-6 col-xl-4 px-lg-2">
              {#each column as grouping}
                <div class="legend" group={grouping['legend'].replace(/ /g,'_')}>{grouping['legend']}</div>
                <div class="custom_radio_buttons" style="margin-top:-10px;display: inline-block;">
                {#each grouping['categories'] as category}
                  {#if grouping['legend'] == 'Sentiment'}
                    <input
                    id={category['value'].replace(/ |\//g,'_')} 
                    name="sentiment" type="radio" 
                    value={category['value']}><label 
                    class={category['class']} 
                    for={category['value'].replace(/ |\//g,'_')} 
                    style="margin-right:3px;">{ category['display'] }</label>
                  {:else}
                    <input bind:group={comment['Category']} 
                    id={category['value'].replace(/ |\//g,'_')} 
                    name="categories" type="radio" 
                    value={category['value']}><label 
                    class={colors[grouping['grouping_num']%4]+'_button'} 
                    for={category['value'].replace(/ |\//g,'_')} 
                    group={grouping['legend'].replace(/ /g,'_')} 
                    style="margin-right:3px;">{ category['display'] }</label>
                  {/if}
                {/each}
                </div>
              {/each}
              </div>
            {/each}
            
            

            <div style="margin-bottom: 1.5rem;"></div>
          </div>
          <div id="other_field_holder" style="display: none;"><div><strong>Other</strong> - Written responses must go through approval before being uploaded</div>
          <input class="form-control form-control-sm" id="other" name="other" type="text" value="">
        </div>
      </fieldset>
      </form>
    </div>

</div>



<!-- Modal for changing category selection set -->
<!-- TODO: write svelte handler to update category and change the categories visible -->
<Modal bind:open={show_model_modal}>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Select a Different Category Set</h5>
        <button type="button" class="close" on:click={()=>{show_model_modal=false;}} data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        {#each Object.entries(choices) as _model,ignore}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div class="btn btn-outline-primary mb-3" 
        on:click={()=>{changeModel(_model[0]);show_model_modal=false;}}
        data-dismiss="modal">{[_model[0]]}</div>
        <br>
      {/each}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" on:click={()=>{show_model_modal=false;}} data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</Modal>

<!-- Modal for keyboard shortcut help -->
<Modal bind:open={show_KBModal}>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Keyboard Shortcuts Help</h5>
        <button type="button" class="close" on:click={()=>(show_KBModal=false)} data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">

        <p>Enter text in the box to filter category selections<br><br>You may also use the following commands:<br></p>
        <table class="table">
          <tr><th>Command</th><th>Action</th></tr>
          <tr><td><kbd>ENTER</kbd> <kbd>ENTER</kbd></td><td>Submit</td></tr>
          <tr><td><kbd>skip</kbd></td><td>Skip</td></tr>
          <tr><td><kbd>+</kbd></td><td>Positive Sentiment</td></tr>
          <tr><td><kbd>-</kbd></td><td>Negative Sentiment</td></tr>
          <tr><td><kbd>neu</kbd></td><td>Neutral Sentiment</td></tr>
        </table>

      </div>
      <p class="small text-muted ml-3">*All functions case insensitive</p>
      <div class="modal-footer">
        <button type="button" on:click={()=>{show_KBModal=false;}} class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</Modal>
